import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/modules/shared.module';
import { AppPrimengModule } from 'app/app-primeng-module';
import { AddOrUpdateDisciplinaryComponent } from 'app/components/home/home-disciplinary/add-or-update-disciplinary/add-or-update-disciplinary.component';

@NgModule({
	declarations: [AddOrUpdateDisciplinaryComponent],
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		AppPrimengModule
	],
	exports: [AddOrUpdateDisciplinaryComponent]
})
export class DisciplinarySharedModule { }
